import EndpointsItems from './items';
import EndpointsMerks from './merks';

const EndpointsThings = {
  ...EndpointsItems,
  ...EndpointsMerks,
} as const;

export default EndpointsThings;
